/* eslint max-classes-per-file: 0 */

import {
  Procedure as Data,
  ProcedureCollection as Collection,
} from '@/typings/api/Procedure'
import { ProceduresPublicationsApi as Api} from '@/api/resources/Collector'

import { Fabric } from '@/store/createCrudModule'

const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class ProceduresTransformerParams extends TransformerParams {
}

export class ProceduresAdapter extends Adapter<Api> {
    public readonly api = new Api();

    public readonly transformerParams = new ProceduresTransformerParams();
}
